export default __webpack_public_path__ + "static/media/html5.3d46777d.png";